import { addDoc, collection, Timestamp } from 'firebase/firestore';

import { firestore } from './client';

export interface WhatsAppContactRequest {
  email: string;
  phone: string;
  createdAt: Date;
  source: string;
  pageUrl?: string;
}

const WHATSAPP_CONTACTS_COLLECTION = 'whatsapp_contact_requests';

export const saveWhatsAppContactRequest = async (
  data: Pick<WhatsAppContactRequest, 'email' | 'phone' | 'source' | 'pageUrl'>,
): Promise<void> => {
  await addDoc(collection(firestore, WHATSAPP_CONTACTS_COLLECTION), {
    email: data.email.trim().toLowerCase(),
    phone: data.phone.trim(),
    source: data.source,
    pageUrl: data.pageUrl ?? window.location.pathname,
    createdAt: Timestamp.fromDate(new Date()),
  });
};
